import {CLOSE_BANNER} from "../actions/Banner"

const BannerReducer = (state = {closeBannerCount: 0, closedBanners: []}, action) => {
  const {id} = action

  switch (action.type) {
    case "CLOSE_BANNER":
      return countUp(state)
    case CLOSE_BANNER:
      return closeBanner(state, id)
    default:
      return state
  }
}

export default BannerReducer

const countUp = (state) => {
  const {closeBannerCount} = state
  return {
    ...state,
    closeBannerCount: closeBannerCount === null ? 0 : closeBannerCount + 1
  }
}

const closeBanner = (state, id) => {
  return {
    ...state,
    closedBanners: [...state.closedBanners, id]
  }
}
